export interface ProductsList {
  HeatingCosts: string;
  FullOperatingCosts: string;
  ColdWaterInvoicing: string;
  ProviderChangeService: string;
  HotWaterInvoicing: string;
}

export const Products: ProductsList = {
  HeatingCosts: 'statement_heating_costs',
  FullOperatingCosts: 'statement_operating_costs',
  ColdWaterInvoicing: 'statement_cold_water',
  ProviderChangeService: 'provider_change_service',
  HotWaterInvoicing: 'statement_hot_water'
};
